import React from "react";
import DataGrid from "components/data-grid";
import EventLiveStream from "./livestream-form";
import FormComposed from "components/form/form-composed";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { PageSection, PageHeaderBar } from "components/page";

const LivestreamData = ({ intl, values, handleChange }) => {
    return (
        <>
            <PageHeaderBar subtitle title="app.page.event.form.livestreams"/>
            <PageSection>
                <DataGrid>
                    <FormComposed
                        name="liveStreams"
                        onChange={handleChange}
                        elements={values.liveStreams}
                        emptyElement={{
                            rtmpUrl: "",
                            key: "",
                            publishingUrl: "",
                            description: "",
                            type: "",
                            isNew: true,
                        }}
                        addSubformButtonText={intl.formatMessage({id: "app.page.event.form.add.emisionData"})}
                        elementComponent={EventLiveStream}
                    />
                </DataGrid>
            </PageSection>
        </>
    )
};

LivestreamData.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default injectIntl(LivestreamData);
